export const PRODUCT_ROLE = Object.freeze({
  primaryChoice: "primary_choice",
  requiredCompanion: "required_companion",
  optionalAddon: "optional_addon",
  clinicianOnly: "clinician_only",
  informational: "informational",
});

export const PRODUCT_ROLE_LABEL = Object.freeze({
  [PRODUCT_ROLE.primaryChoice]: "Choose one",
  [PRODUCT_ROLE.requiredCompanion]: "Required",
  [PRODUCT_ROLE.optionalAddon]: "Optional",
  [PRODUCT_ROLE.clinicianOnly]: "Clinician selected",
  [PRODUCT_ROLE.informational]: "Included information",
});
